<template>
  <div class="l-home">
    <div class="c-home">
      <!-- <video-background src="../assets/home-video.mp4" style="min-height: 900px;  width:100vw; opacity:0.8; height: 800px">
        <video loop autoplay muted style="width:100vw;">
          <source src="../assets/home-video.mp4" type="video/mp4" />
        </video>
      </video-background>-->
      <video-background :src="require(`../assets/home-video.mp4`)" loop autoplay muted>
        <!-- <video loop autoplay muted style="width:100vw;"> -->
        <!-- </video> -->
      </video-background>
      <!-- <img src="@/assets/images/capa.png" alt="catalogo" class="cover-home" /> -->
      <!-- Video home page -->
    </div>

    <div>
      <Destaques />
    </div>
    <div class="video-wrapper-youtube">
      <youtube :video-id="videoId" ref="youtube"></youtube>
    </div>
  </div>
</template>

<script>
import Destaques from "@/components/Destaques";
import getYouTubeID from "get-youtube-id";
export default {
  name: "Home",
  components: { Destaques },
  data() {
    return {
      videoId: getYouTubeID("https://www.youtube.com/watch?v=bRkL_ZmGdEY"),
    };
  },
};
</script>

<style lang="scss" scoped></style>
